<template>
  <a-modal class="coverBox" v-model="visible" :title="title" @ok="ok" destroyOnClose :maskClosable="false">
    <a-form :form="form" class="headForm" :label-col="labelCol">
      <a-form-item label="原料代码">{{details.code}}</a-form-item>
      <a-form-item label="目标原料">
        <a-select
          show-search
          placeholder="请输入名称/代码"
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          @search="getSearchList"
          @select="onSelect"
          v-decorator="['name',{ rules: [{ required: true, message: '请输入名称/代码' }] }]"
        >
          <a-select-option v-for="d in searchList" :key="d.rawId">
            {{ d.firstName }}<span style="color: red">{{ d.midName }}</span
            >{{ d.lastName }}({{ d.code }})
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
export default {
  data(){
    return{
      visible: false,
      details: {},
      form: this.$form.createForm(this),
      searchList: [],
      labelCol: { style: { width: '100px' } },
    }
  },
  computed: {
    title(){
      return <div style="width: 455px;">{this.details.name || ''}<span style="color: #929292;font-size: 12px;margin-left: 2px;">将原料的营养指标数值覆盖到其他原料</span></div>
    }
  },
  methods:{
    init(record){
      this.visible = true
      this.details = record
      this.selected = false
    },
    ok(){
      // this.visible = false
      this.form.validateFields((err,values) => {
        if(!err){
          if(!this.selected) {
            this.$message.warning('请选择目标原料')
            return
          }
          let {name:targetRawId} = values || {}
          let {rawId: copyRawId,staffId: copyStaffId} = this.details || {}
          let data = {
            copyFactoryId: window.localStorage.getItem('factoryId'),
            copyRawId, copyStaffId, targetRawId
          }
          if(copyRawId === targetRawId){
            this.$message.warning('目标原料不能和覆盖原料相同')
          }else{
            this.$http.post('/nhf-app/factorystaffraw/factoryStaffRawCover',data).then(res => {
              let {success} = res || {}
              if(success){
                this.$message.success('操作成功')
                this.visible = false
              }
            })
          }
        }
      })
    },
    getSearchList(name) {
      if (name) {
        setTimeout(() => {
          this.placeStr = name || "请输入指标名称";
          this.form.setFieldsValue({ name });
          this.$get("/nhf-app/factorystaffraw/myRawpage", {
            current: 1,
            size: 100,
            factoryId: window.localStorage.getItem("factoryId"),
            name,
          })
            .then((res) => {
              let { success, data } = res;
              if (success) {
                let { records } = data || {};
                records.map((el) => {
                  let nameArr = el.name.split(name);
                  el.firstName = nameArr[0];
                  el.lastName = nameArr[1];
                  el.midName = name;
                  return el;
                });
                this.searchList = records || [];
              } else {
                this.searchList = [];
              }
            })
            .catch(() => {
              this.searchList = [];
            });
        }, 300);
      }
    },
    onSelect() {
      // this.getList({ pageSize: 20, current: 1, val });
      // console.log(val,'---------')
      this.selected = true
      // let data = {
      //   copyFactoryId: 1386613070195792193,
      //   copyRawId: 1386613070175752193,
      //   copyStaffId: 1414518028278755329,
      //   targetRawId: 1386613070175752464
      // }
    },
  }
}
</script>
<style lang="scss">
.coverBox{
  .ant-modal-body{
    padding: 0
  }
}
</style>